<script>
    export default {
        name: "GroupItemsMixin",

        methods: {
            groupByFields(source, field1, field2) {
                let fields1 = field1.split('.');
                let fields2 = field2 ? field2.split('.') : null;

                let result = {};
                source.forEach(item => {
                    let field1Val = item;
                    fields1.forEach(field => {
                        field1Val = field1Val[field];
                    });
                    let field2Val = item;
                    if (fields2) {
                        fields2.forEach(field => {
                            field2Val = field2Val[field];
                        });
                    }

                    if (!result[field1Val]) {
                        result[field1Val] = fields2 ? {} : [];
                    }
                    if (fields2 && !result[field1Val][field2Val]) {
                        result[field1Val][field2Val] = [];
                    }
                    if (fields2) {
                        result[field1Val][field2Val].push(item);
                    } else {
                        result[field1Val].push(item);
                    }
                });
                return result;
            },

            calcCount(group) {
                let result = 0;
                for (let key in group) {
                    if (group.hasOwnProperty(key)) {
                        result += group[key].length;
                    }
                }
                return result;
            },
        },
    }
</script>